module.exports = __webpack_public_path__ + "img/hz-hfg.be2902c4.jpg";